const softBreak = {
	group: "inline",
	inline: true,
	atom: true,
	selectable: false,
};

export default softBreak;
